<script setup lang="ts">
import { resizeImage, resizeImageSrcsetWidths } from '~/shared/lib/resizeImage';
import { EVENT_CARD_IMAGE_WIDTHS } from '~/shared/lib/events-images.const';

const props = defineProps<{
  image: string;
  title: string;
  link: string;
}>();

/*
  The box ratio changes between breakpoints, so the image is only scaled down:
  a server crop would be cut again by a wider box.
*/
const imageSrc = computed(() => resizeImage(props.image, { width: 320 }));

const imageSrcset = computed(() =>
  resizeImageSrcsetWidths(props.image, EVENT_CARD_IMAGE_WIDTHS),
);
</script>

<template>
  <NuxtLink :to="link" :class="$style.card">
    <div :class="$style.photo">
      <img
        :src="imageSrc"
        :srcset="imageSrcset || undefined"
        sizes="(max-width: 1023px) 50vw, 320px"
        :alt="title"
        :class="$style.img"
      />
    </div>
    <div :class="$style.info">
      <span :class="$style.category">Мероприятия</span>
      <span :class="$style.title">{{ title }}</span>
    </div>
  </NuxtLink>
</template>

<style module lang="scss">
.card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: var(--space-2-5x);
  gap: var(--space-1-5x);
  text-decoration: none;
  min-height: 268px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
}

.photo {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: var(--color-gray-bg);
}

.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info {
  display: flex;
  flex-direction: column;
  gap: var(--space-1x);
}

.category {
  @include text_caption2_caps;
  color: var(--color-gray-text);
}

.title {
  @include text_body2;
  color: var(--color-black-1);
  @include line_clamp(3);
}

@media (max-width: 767px) {
  .card {
    min-height: 240px;
  }

  .photo {
    height: 150px;
  }
}
</style>
